<script>
import Vue from "vue";
import draggable from "vuedraggable";

const CustomDraggable = Vue.extend(draggable).extend({
  computed: {
    rootContainer() {
      return this.$el.querySelector('tbody');
    },
  },
  methods: {
    getChildrenNodes() {
      return Array.from(this.rootContainer.querySelectorAll('tr'));
    },
    getUnderlyingVm(htmlElt) {
      const index = this.getChildrenNodes().indexOf(htmlElt);
      if (index === -1) {
        //Edge case during move callback: related element might be
        //an element different from collection
        return null;
      }
      const element = this.realList[index];
      return {index, element};
    },
  }
});

export default {
  name: 'DraggableElTable',
  render(createElement) {
    return createElement(CustomDraggable, {
      attrs: {
        draggable: "tr.el-table__row",
        direction: "vertical",
        handle: ".handle"
      },
      on: this._events
    }, this.$slots.default);
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  .handle {
    transform: scaleX(0.5) translateY(-50%);
    cursor: grab;
    position: absolute;
    top: 50%;
    left: 0;
  }

  .sortable-chosen .handle {
    cursor: grabbing;
  }
}
</style>
